import { render, staticRenderFns } from "./PostView.vue?vue&type=template&id=295e2698&scoped=true&"
import script from "./PostView.vue?vue&type=script&lang=js&"
export * from "./PostView.vue?vue&type=script&lang=js&"
import style0 from "./PostView.vue?vue&type=style&index=0&id=295e2698&lang=scss&scoped=true&"
import style1 from "./PostView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e2698",
  null
  
)

export default component.exports